import {ILayoutRow} from '../_interface/layout';

export const getPositionInLayout = (rows: ILayoutRow[], templateFieldId: string): [row: number, column: number] => {
	if (!rows || !templateFieldId) return [null, null];
	return rows.reduce((acc, currentRow, i) => {
		const pos = currentRow.findIndex(f => f.templateFieldId === templateFieldId);
		if (pos !== -1) return [i, pos];
		return acc[0] === null && acc[1] === null ? [-1, -1] : acc;
	}, [null, null]) as [row: number, column: number];
};

export const getPositionInLayoutAsObject = (rows: ILayoutRow[], templateFieldId: string): {row: number, column: number} => {
	const [row, column] = getPositionInLayout(rows, templateFieldId);
	return {row, column};
};
